export default {
  archidektOrange: '#fa890d',
  quantityBlue: '#698bc7',
  quantityGreen: '#1ebb6c',
}
